module.exports = __webpack_public_path__ + "img/logo-white.10e32a82.png";